import Stepper from "./Stepper";
import Button from "../../../components/ui/buttons/Button";
import CheckListItem from "../../../components/ui/CheckListItem";

const pretupClientSpace = process.env.REACT_APP_USER_DASHBOARD;

const Invest = () => {
  return <div className="mb-12 lg:max-w-7xl mx-auto">
    <h2 className="mb-6 text-4xl font-bold text-white bg-secondary py-3 rounded-lg text-center shadow-lg">
      Réalisez votre 1er prêt en quelques clics
    </h2>
    <Stepper />
    <div className="mb-12 flex flex-col md:grid md:grid-cols-2 mx-auto max-w-xl gap-y-6">
      <CheckListItem className="justify-self-start" text={"Pas de frais d’inscription"} iconSize={25} textClass="text-lg font-semibold text-gray-600 flex items-center" />
      <CheckListItem className="justify-self-end" text={"Pas de frais de gestion"} iconSize={25} textClass="text-lg font-semibold text-gray-600 flex items-center" />
      <CheckListItem className="col-span-2" text={"Aucun engagement jusqu’à ce que vous soyez prêt à investir"} iconSize={25} textClass="text-lg text-gray-600 flex items-center" />
    </div>
    <div className="text-center mx-auto max-w-2xl px-4 sm:px-6 md:mb-14 lg:max-w-7xl lg:px-8">
      <Button
        text="Commencez à investir"
        link={{ external: false, href: "/inscription/preteur" }}
        tailwindClass="text-black mb-4"
        btnType="secondary"
        hover={true}
      />
      <h3 className="text-gray-600 italic">Devenez des investisseurs engagés dans l’économie réelle dès 20€</h3>
      <Button
        text="En savoir plus"
        link={{ external: false, href: '/preter/preter-a-des-entreprises' }}
        btnType="transparentSecondary"
      />
    </div>
  </div>
}

export default Invest;